// extracted by mini-css-extract-plugin
export var content_date = "content-detail-module--content_date--2YAka";
export var content_tag = "content-detail-module--content_tag--2_zOp";
export var list = "content-detail-module--list--3IE93";
export var item = "content-detail-module--item--weMFj";